<template>
  <div>
    <font-awesome-icon v-bind="$props"></font-awesome-icon>
  </div>
</template>

<script lang="ts" setup>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
  import type { MIconProps } from './';

  const props = defineProps<MIconProps>();
</script>
